<template>
  <div class="progress-track">
    <div
      class="progress-fill"
      :style="{ width: `${clampedPercentage}%` }"
      role="progressbar"
      :aria-valuenow="clampedPercentage"
      aria-valuemin="0"
      aria-valuemax="100"
    />
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'MemberLevelProgressBar',
  props: {
    percentage: {
      type: Number,
      default: 0,
    },
  },
  setup (props) {
    const clampedPercentage = computed(() => Math.min(100, Math.max(0, props.percentage || 0)))
    return { clampedPercentage }
  },
})
</script>

<style scoped lang="postcss">
.progress-track {
  @apply w-full h-1.5 rounded-full bg-gray-20 overflow-hidden;
}

.progress-fill {
  @apply h-full rounded-full bg-action;
  transition: width 0.3s ease-out;
}
</style>
